<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="text-center">
      <h4>{{ title }}</h4>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form ref="model" :rules="rules" :model="model" label-width="100px">
        <el-form-item label="名称" prop="labelName">
          <el-input :readonly="isReadonly" @change='checkAllInputs' placeholder="请输入名称" v-model.trim="model.labelName"
            class="input-width"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="formulaType">
          <el-select v-if="!isReadonly" :disabled="isReadonly" @change='checkAllInputs' v-model="model.formulaType"
            placeholder="请选择类型">
            <el-option v-for="(item, index) in formulaTypeList" :key="index" :label="item.Value" :value="item.Key"></el-option>
          </el-select>
          <el-input v-if="isReadonly" :readonly="isReadonly" v-model="model.formulaTypeText" class="input-width"></el-input>
        </el-form-item>
        <el-form-item label="" prop="isRelatedInTerm" v-show="model.formulaType == 1 && model.accountType == 2">
          <el-checkbox :readonly="isReadonly" :disabled="isReadonly" @change='checkAllInputs' v-model="model.isRelatedInTerm"
            class="input-width">是否课程连报</el-checkbox>
        </el-form-item>
        <el-form-item label="学期" prop="termIds" v-show="model.formulaType == 1 && hasTerm">
          <el-select placeholder="请选择学期" @change='checkAllInputs' :multiple="true" size="medium" v-model="model.termIds" class="input-width">
            <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学校分组" prop="universityGroups" v-show="model.formulaType == 1">
          <el-select placeholder="请选择学校分组" @change='checkAllInputs' :multiple="true" size="medium" v-model="model.universityGroups" class="input-width">
            <el-option v-for="item in universityGroups" :key="item.IdValue" :label="item.NameValue" :value="item.GroupNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="编码" prop="code" v-show="model.formulaType == 1">
          <el-input :readonly="isReadonly" @change='checkAllInputs' placeholder="请输入编码" v-model.trim="model.code"
            class="input-width"></el-input>
          <el-button v-loading="isGenerateCode" type="primary" size="mini" @click="onCodeGenerate">生成</el-button>
        </el-form-item>
        <el-form-item label="变量名" prop="variableName">
          <el-input :readonly="isReadonly" @change='checkAllInputs' placeholder="请输入变量名" v-model.trim="model.variableName"
            class="input-width"></el-input>
        </el-form-item>
        <el-form-item label="映射变量名" prop="mapVariableName">
          <el-input :readonly="isReadonly" @change='checkAllInputs' placeholder="请输入映射变量名" v-model.trim="model.mapVariableName"
            class="input-width"></el-input>
        </el-form-item>
        <el-form-item label="" prop="isEnable">
          <el-checkbox :readonly="isReadonly" :disabled="isReadonly" @change='checkAllInputs' v-model="model.isEnable"
            class="input-width">是否启用</el-checkbox>
        </el-form-item>
        <el-form-item label="" prop="isBonusPoint">
          <el-checkbox :readonly="isReadonly" :disabled="isReadonly" @change='checkAllInputs' v-model="model.isBonusPoint"
            class="input-width">是否积分公式</el-checkbox>
        </el-form-item>
        <el-form-item label="" prop="isBonusPointDeduction">
          <el-checkbox :readonly="isReadonly" :disabled="isReadonly" @change='checkAllInputs'
            v-model="model.isBonusPointDeduction" class="input-width">是否抵扣积分</el-checkbox>
        </el-form-item>
        <el-form-item label="" v-if="model.isBonusPointDeduction" prop="bonusPointDeduction">
          <el-input :readonly="isReadonly" @change='checkAllInputs' placeholder="请输入抵扣积分数额" v-model="model.bonusPointDeduction"
            class="input-width"></el-input>
        </el-form-item>
        <el-form-item label="公式" prop="value">
          <el-input :readonly="isReadonly" @change='checkAllInputs' type="textarea" :rows="5" placeholder="请输入公式"
            v-model.trim="model.value" class="input-width"></el-input>
        </el-form-item>

      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer" v-if="!isReadonly">
      <el-row>
        <el-col :span="16" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
        <el-col class="footer-right" :span="8">
          <el-button v-if="model.formulaType == 1" :disabled="testBtnDisable" type="warning" @click="test()">测试</el-button>
          <el-button :disabled="submitBtnDisable" :type="submitBtnClass" @click="save()">{{ isAdded || isCopy ? '确认添加' : '保存更新'}}</el-button>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="测试失败" top="1vh" :modal="false" :modal-append-to-body="false" :visible.sync="testResultDialogVisible"
      width="80%" center>
      <div class="cs-testResultDialog-message">
        <div>错误信息：</div>
        <div>{{testErrorMsg}}</div>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.cs-testResultDialog-message {
  padding: 0.5rem 3rem 1rem 3rem;
}
</style>

<script>
import {
  saveFormula,
  getFormulaTypeList,
  testFormula,
} from "../../service/finance.service";
import {
  generateCode,
  getUniversityGroups,
} from "../../service/common.service";

export default {
  props: {
    termList: Array,
    data: {},
    dialogVisible: false,
  },
  data() {
    let validateBonusPointDeduction = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入数字";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      model: {
        id: 0,
        labelName: "",
        code: "",
        universityGroups: [],
        variableName: "",
        mapVariableName: "",
        value: "",
        accountType: 1,
        formulaType: 1,
        formulaTypeText: "",
        isBonusPoint: false,
        isBonusPointDeduction: false,
        isEnable: false,
        bonusPointDeduction: 0,
        termIds:[],
        isRelatedInTerm: 0
      },
      hasTerm: true,
      universityGroups: [],
      isGenerateCode: false,
      isReadonly: false,
      testResultDialogVisible: false,
      testErrorMsg: "",
      testBtnDisable: false,
      submitBtnClass: "info",
      submitBtnDisable: true,
      isAdded: false,
      isCopy: false,
      title: "",
      showError: false,
      errorMessage: "",
      formulaTypeList: [],
      rules: {
        labelName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
          {
            min: 0,
            max: 250,
            message: "最大长度在为250个字符",
            trigger: "blur",
          },
        ],
        code: [
          {
            min: 0,
            max: 50,
            message: "最大长度在为50个字符",
            trigger: "blur",
          },
        ],
        variableName: [
          {
            required: true,
            message: "请输入变量名",
            trigger: "blur",
          },
          {
            min: 0,
            max: 250,
            message: "最大长度在为250个字符",
            trigger: "blur",
          },
        ],
        mapVariableName: [
          {
            min: 0,
            max: 250,
            message: "最大长度在为250个字符",
            trigger: "blur",
          },
        ],
        value: [
          {
            required: true,
            message: "请输入公式",
            trigger: "blur",
          },
        ],
        bonusPointDeduction: [
          {
            required: true,
            message: "请输入抵扣积分数额",
            trigger: "blur",
          },
          {
            validator: validateBonusPointDeduction,
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {},
  created() {
    
    getUniversityGroups().then((result) => {
      if (!!result && result.success) {
        let data = result.data;
        this.universityGroups = result.data;
      }
    });

    if (!this.formulaTypes || this.formulaTypes.length == 0) {
      getFormulaTypeList().then((result) => {
        if (result.success) {
          this.formulaTypeList = result.data;
        }
      });
    }

    this.loadData();
  },
  methods: {
    test() {
      let isValid = true;
      this.$refs.model.validate((valid) => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      if (!isValid) {
        return;
      }

      this.testBtnDisable = true;
      testFormula(
        this.model.id,
        this.model.accountType,
        this.model.labelName,
        this.model.universityGroups,
        this.model.code,
        this.model.variableName,
        this.model.mapVariableName,
        this.model.value,
        this.model.formulaType,
        this.model.isBonusPoint,
        this.model.isBonusPointDeduction,
        this.model.bonusPointDeduction,
        this.model.isEnable,
        this.model.termIds,
        this.model.isRelatedInTerm
      )
        .then((result) => {
          if (!!result && result.success) {
            if (result.data.IsSuccess) {
              this.$message.success("测试成功");
            } else {
              this.testErrorMsg = result.data.Message;
              this.testResultDialogVisible = true;
            }
          } else {
            this.$message.error(result.message);
          }
          this.testBtnDisable = false;
        })
        .catch((ex) => {
          this.testBtnDisable = false;
        });
    },
    checkAllInputs() {
      if (this.isReadonly) return;

      let isValid = true;
      this.$refs.model.validate((valid) => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      if (isValid) {
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
      }
    },
    save() {
      if (!!this.$refs["model"]) {
        let isValid = true;
        this.$refs["model"].validate((valid) => {
          if (valid) {
          } else {
            isValid = false;
          }
        });
        if (!isValid) {
          return false;
        }
        this.submitBtnDisable = true;
        let result = saveFormula(
          this.model.id,
          this.model.accountType,
          this.model.labelName,
          this.model.universityGroups,
          this.model.code,
          this.model.variableName,
          this.model.mapVariableName,
          this.model.value,
          this.model.formulaType,
          this.model.isBonusPoint,
          this.model.isBonusPointDeduction,
          this.model.bonusPointDeduction,
          this.model.isEnable,
          this.model.termIds,
          this.model.isRelatedInTerm
        ).then((result) => {
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            this.$message("保存成功！");
            this.showError = false;

            this.$emit("saveSuccess", this.isAdded || this.isCopy, result.data);
            this.close();
          }
          this.submitBtnDisable = false;
        });
      }
    },
    close() {
      //this.$refs["model"].resetFields();
      this.$emit("closeDialog");
    },
    loadData() {
      if (!!this.data && (!!this.data.Id || this.data.FormulaType == 2 || this.data.IsCopy)) {
      
        this.hasTerm = this.data.AccountType === 1 || this.data.AccountType === 2;
        this.isAdded = false;
        if (this.data.IsCopy){
          this.isCopy = true;
          this.title = "复制公式";
        }else{
          this.isCopy = false;
          this.title = "编辑公式";
        }
        
        this.model.id = this.data.Id;
        this.model.accountType = this.data.AccountType;
        this.model.labelName = this.data.LabelName;
     
        this.model.universityGroups = this.data.UniversityGroups;
        this.model.code = this.data.Code;
        this.model.variableName = this.data.VariableName;
        this.model.mapVariableName = this.data.MapVariableName;
        this.model.value = this.data.Value;
        this.model.formulaType = this.data.FormulaType;
        this.model.formulaTypeText = this.data.FormulaTypeText;
        this.model.isBonusPoint = this.data.IsBonusPoint;
        this.model.isBonusPointDeduction = this.data.IsBonusPointDeduction;
        this.model.bonusPointDeduction = this.data.BonusPointDeduction;
        this.model.isEnable = this.data.Enable;
        this.model.termIds = this.data.TermIds;
        this.model.isRelatedInTerm = this.data.IsRelatedInTerm;
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
        if (this.model.formulaType == 2) {
          this.isReadonly = true;
        } else {
          this.isReadonly = false;
        }
      } else {
        this.title = "新增公式";
        this.isCopy = false;
        this.isReadonly = false;
        this.isAdded = true;
        this.model.id = 0;
        if (!!this.data && !!this.data.AccountType) {
          this.model.accountType = this.data.AccountType;
        } else {
          this.model.accountType = 0;
        }

        this.model.labelName = "";
        this.model.code = "";
        this.model.universityGroups = [];
        this.model.variableName = "";
        this.model.mapVariableName = "";
        this.model.value = "";
        this.model.formulaType = 1;
        this.model.formulaTypeText = "";
        this.model.isBonusPoint = false;
        this.model.isBonusPointDeduction = false;
        this.model.bonusPointDeduction = 0;
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
        this.model.isEnable = true;
        this.model.termIds = [];
        this.model.isRelatedInTerm = false;
      }
    },
    onCodeGenerate() {
      this.isGenerateCode = true;
      generateCode(1).then((result) => {
        if (result && result.success) {
          this.model.code = result.data;
        } else {
          this.$message.error(result.message);
        }
        this.isGenerateCode = false;
      });
    },
  },
  watch: {
    data: function () {
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/finance/formulaEdit.vue